import type { FormField } from "@tellescope/types-models";

/**
 * Widens the set of navigated field ids to include the sub-fields of any Question
 * Group in it, so a group's answers are submitted alongside the group.
 *
 * Sub-fields hidden by an unsatisfied `groupShowCondition` are left out — they were
 * never shown, so their values must not be submitted.
 *
 * @param fieldsMap all fields by id, used to find which included ids are groups
 * @param isSubFieldHidden whether a sub-field is currently hidden by its show condition
 */
export const expandSubmittedFieldIds = (
  includedFieldIds: ReadonlySet<string>,
  fieldsMap: Record<string, FormField | undefined>,
  isSubFieldHidden: (fieldId: string) => boolean
): Set<string> =>
  Array.from(includedFieldIds).reduce((acc, fieldId) => {
    const field = fieldsMap[fieldId];
    if (field?.type !== "Question Group") return acc;
    return (field.options?.subFields ?? []).reduce(
      (withSubFields, sf) => (isSubFieldHidden(sf.id) ? withSubFields : withSubFields.add(sf.id)),
      acc
    );
  }, new Set(includedFieldIds));
